import * as angular from "angular";
import { EslIdAuthService } from "./EslIdAuthService";
declare var Drupal: any;

export class EslIdAuthInterceptor implements angular.IHttpInterceptor {
    public refreshTokenRequest: angular.IPromise<any> = null;
    private excludedPaths: string[] = ["/user/oauth2/access-token"];

    public static factory = [
        "$injector",
        "$q",
        "EslIdAuthService",
        ($injector, $q: angular.IQService, EslIdAuthService: EslIdAuthService): EslIdAuthInterceptor => {
            return new EslIdAuthInterceptor($injector, $q, EslIdAuthService);
        },
    ];

    public static $inject = ["$injector", "$q", "EslIdAuthService"];

    constructor(private $injector, private $q: angular.IQService, private EslIdAuthService: EslIdAuthService) {}

    public request = (config: angular.IRequestConfig): angular.IRequestConfig => {
        // if we are on an excluded path, do not set the Authorization header
        if (this.excludedPaths.indexOf(config.url) !== -1) {
            return config;
        }

        if (config.headers["Authorization"] || (!Drupal.settings.user || !Drupal.settings.user.id)) {
            return config;
        }

        const token = this.EslIdAuthService.getAuthToken(Drupal.settings.user.id);
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }

        return config;
    };

    public responseError = (response): angular.IPromise<any> => {
        if (this.excludedPaths.indexOf(response.config.url) !== -1) {
            return this.$q.reject(response);
        }

        if (response.status === 401 && Drupal.settings.user && Drupal.settings.user.id) {
            // Return a new promise
            const token = this.EslIdAuthService.getAuthToken(Drupal.settings.user.id);

            if (!this.refreshTokenRequest) {
                this.refreshTokenRequest = this.$injector
                    .get("$http")
                    .get("/user/oauth2/access-token")
                    .then(res => {
                        this.refreshTokenRequest = null;
                        this.EslIdAuthService.setAuthToken(Drupal.settings.user.id, res.headers("X-Auth-Token"));
                        return this.$q.resolve(res);
                    })
                    .catch(error => {
                        this.refreshTokenRequest = null;
                        return this.$q.reject(error);
                    });
            }

            return this.refreshTokenRequest
                .then(res => {
                    response.config.headers["Authorization"] = `Bearer ${res.headers("X-Auth-Token")}`;
                    return this.$injector.get("$http")(response.config);
                })
                .catch(error => {
                    return this.$q.reject(response);
                });
        }

        /* If not a 401, do nothing with this error.
         * This is necessary to make a `responseError`
         * interceptor a no-op. */
        return this.$q.reject(response);
    };
}
